import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

import { throwError } from 'rxjs';



import { HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;
@Injectable()
export class ChangeProductService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService, private adobeAnalyticsService: AdobeAnalyticsService) { }

  getApplicableProductMock(getPricingDetailsservice) {
    return this.httpClientService.get(getPricingDetailsservice)
      .pipe(
       map((test: HttpResponse<any>) => test)
      ,catchError( this.handleError ));
  }

  getEligibleProductForCtnMock(getProductDetailsservice) {
    return this.httpClientService.get(getProductDetailsservice)
      .pipe(
       map((test: HttpResponse<any>) => test)
      ,catchError( this.handleError ));
  }

  getApplicableProductDetails(getPricingDetailsservice, requestPriceInfoObj) {
    return this.genericPostApiInvoke(getPricingDetailsservice, requestPriceInfoObj);
  }

  getEligibleProductForCtnDetails(getPricingDetailsservice, requestPriceInfoObj) {
    return this.httpClientService.authorizedPut(getPricingDetailsservice, requestPriceInfoObj)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  getPricingInfo(getPricingDetailsservice, requestPriceInfoObj) {
    return this.genericPostApiInvoke(getPricingDetailsservice, requestPriceInfoObj);
  }

  genericPostApiInvoke(getPricingDetailsservice, requestPriceInfoObj) {
    return this.httpClientService.authorizedPost(getPricingDetailsservice, requestPriceInfoObj)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  // Page Load
  createPageLoadProperties(dcmCode: string, url: string, pageTitle: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_CHANGE_PRODUCT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_CHANGE_PRODUCT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SKU] = dcmCode;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'manage';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  handleError = (error) => {
    return throwError(error);
  }
}
